/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import { handleBlobResponse } from '../../../../client/js/lib/download'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function deleteManagementReport (id: number) {
  return rest.delete(`/api/management-reports/${id}`)
}

export function fetchManagementReportData (params?: {
  year: number,
  month?: number,
  customerId: number,
  estateId?: number
  leaseId?: number
  isManagementReport: boolean
}): Promise<ManagementReportData> {
  return rest.get(`/api/management-reports/data?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function downloadManagementReport (params: {
  year: number,
  month?: number,
  customerId: number,
  estateId?: number
  leaseId?: number
}) {
  return rest.get(`/api/management-reports/download?${stringify(params)}`)
    .then(handleBlobResponse)
}

export function downloadManagementReports (params: {
  year?: number,
  customerId?: number,
  leaseId?: number,
  ids?: number[]
}) {
  return rest.get(`/api/management-reports/download-archive?${stringify(params)}`)
    .then(handleBlobResponse)
}

export function fetchManagementReportJobs (params?: { status: string }): Promise<{
  data: number[]
}> {
  return rest.get(`/api/management-reports/jobs?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function fetchManagementReportYears (): Promise<{ data: number[] }> {
  return rest.get('/api/management-reports/years')
    .then((resp) => resp.json())
}

export function fetchManagementReportYearsAvailable (params?: {
  customerId?: number,
  estateId?: number,
  leaseId?: number,
}): Promise<{ data: number[] }> {
  return rest.get(`/api/management-reports/years-available?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function fetchManagementReports (params?: Record<string, any>): Promise<HalDocument<{
  managementReports: ManagementReport[]
}>> {
  return rest.get(`/api/management-reports?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function generateManagementReports (params: {
  customerId: number,
  estateId: number,
  year: number
}) {
  return rest.post(`/api/management-reports/generate?${stringify(params)}`)
    .then((resp) => resp.json())
}
